import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClientService } from '../../shared/services/api-client.service';
import { AB_API_SENTOO_CREATE } from '../../shared/constants';
import { Transfer } from './payment-details.service';

export interface TransferModel {
  transferId: number;
  beneficiaryName: string;
  beneficiaryHouseNumber: string | null;
  beneficiaryStreet: string | null;
  beneficiaryCity: string | null;
  beneficiaryPostalCode: string | null;
  beneficiaryInstitutionName: string;
  beneficiaryInstitutionCode: string;
  beneficiaryInstitutionCodeValue: string;
  valueDate: string;
  description: string;
  destinationCountryIsoCode?: string;
  sourceAccount: string | null;
  beneficiaryAccount: string;
  currency: string;
  amount: number;
  referenceCategoryNumber: string | null;
  sentooTransactionId: string;
  sentooProcessorId: string;
  transactionType: string;
}
@Injectable({
  providedIn: 'root',
})
export class CreateSentooPaymentService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_SENTOO_CREATE);
  }

  getChallengeNumber(request: TransferModel): Observable<any> {
    return this.post(request);
  }
}
